export default "__VITE_ASSET__a3hmPFl2__"